import React from "react";
import * as Flags from "@xsolla/xui-icons-flag";
import type { FlagIconComponent } from "@xsolla/xui-icons-flag";
import { getExampleNumber, type CountryCode } from "libphonenumber-js";
import examples from "libphonenumber-js/examples.mobile.json";
import type { Country } from "./InputPhone";

// Map of ISO country codes to flag component names
const flagMap: Record<string, FlagIconComponent> = {
  AD: Flags.FlagAD,
  AE: Flags.FlagAE,
  AF: Flags.FlagAF,
  AG: Flags.FlagAG,
  AI: Flags.FlagAI,
  AL: Flags.FlagAL,
  AM: Flags.FlagAM,
  AO: Flags.FlagAO,
  AQ: Flags.FlagAQ,
  AR: Flags.FlagAR,
  AS: Flags.FlagAS,
  AT: Flags.FlagAT,
  AU: Flags.FlagAU,
  AW: Flags.FlagAW,
  AX: Flags.FlagAX,
  AZ: Flags.FlagAZ,
  BA: Flags.FlagBA,
  BB: Flags.FlagBB,
  BD: Flags.FlagBD,
  BE: Flags.FlagBE,
  BF: Flags.FlagBF,
  BG: Flags.FlagBG,
  BH: Flags.FlagBH,
  BI: Flags.FlagBI,
  BJ: Flags.FlagBJ,
  BL: Flags.FlagBL,
  BM: Flags.FlagBM,
  BN: Flags.FlagBN,
  BO: Flags.FlagBO,
  BQ: Flags.FlagBQ,
  BR: Flags.FlagBR,
  BS: Flags.FlagBS,
  BT: Flags.FlagBT,
  BW: Flags.FlagBW,
  BY: Flags.FlagBY,
  BZ: Flags.FlagBZ,
  CA: Flags.FlagCA,
  CC: Flags.FlagCC,
  CD: Flags.FlagCD,
  CF: Flags.FlagCF,
  CG: Flags.FlagCG,
  CH: Flags.FlagCH,
  CI: Flags.FlagCI,
  CK: Flags.FlagCK,
  CL: Flags.FlagCL,
  CM: Flags.FlagCM,
  CN: Flags.FlagCN,
  CO: Flags.FlagCO,
  CR: Flags.FlagCR,
  CU: Flags.FlagCU,
  CV: Flags.FlagCV,
  CW: Flags.FlagCW,
  CX: Flags.FlagCX,
  CY: Flags.FlagCY,
  CZ: Flags.FlagCZ,
  DE: Flags.FlagDE,
  DJ: Flags.FlagDJ,
  DK: Flags.FlagDK,
  DM: Flags.FlagDM,
  DO: Flags.FlagDO,
  DZ: Flags.FlagDZ,
  EC: Flags.FlagEC,
  EE: Flags.FlagEE,
  EG: Flags.FlagEG,
  EH: Flags.FlagEH,
  ER: Flags.FlagER,
  ES: Flags.FlagES,
  ET: Flags.FlagET,
  FI: Flags.FlagFI,
  FJ: Flags.FlagFJ,
  FK: Flags.FlagFK,
  FM: Flags.FlagFM,
  FO: Flags.FlagFO,
  FR: Flags.FlagFR,
  GA: Flags.FlagGA,
  GB: Flags.FlagGB,
  GD: Flags.FlagGD,
  GE: Flags.FlagGE,
  GF: Flags.FlagGF,
  GG: Flags.FlagGG,
  GH: Flags.FlagGH,
  GI: Flags.FlagGI,
  GL: Flags.FlagGL,
  GM: Flags.FlagGM,
  GN: Flags.FlagGN,
  GP: Flags.FlagGP,
  GQ: Flags.FlagGQ,
  GR: Flags.FlagGR,
  GS: Flags.FlagGS,
  GT: Flags.FlagGT,
  GU: Flags.FlagGU,
  GW: Flags.FlagGW,
  GY: Flags.FlagGY,
  HK: Flags.FlagHK,
  HN: Flags.FlagHN,
  HR: Flags.FlagHR,
  HT: Flags.FlagHT,
  HU: Flags.FlagHU,
  ID: Flags.FlagID,
  IE: Flags.FlagIE,
  IL: Flags.FlagIL,
  IM: Flags.FlagIM,
  IN: Flags.FlagIN,
  IO: Flags.FlagIO,
  IQ: Flags.FlagIQ,
  IR: Flags.FlagIR,
  IS: Flags.FlagIS,
  IT: Flags.FlagIT,
  JE: Flags.FlagJE,
  JM: Flags.FlagJM,
  JO: Flags.FlagJO,
  JP: Flags.FlagJP,
  KE: Flags.FlagKE,
  KG: Flags.FlagKG,
  KH: Flags.FlagKH,
  KI: Flags.FlagKI,
  KM: Flags.FlagKM,
  KN: Flags.FlagKN,
  KP: Flags.FlagKP,
  KR: Flags.FlagKR,
  KW: Flags.FlagKW,
  KY: Flags.FlagKY,
  KZ: Flags.FlagKZ,
  LA: Flags.FlagLA,
  LB: Flags.FlagLB,
  LC: Flags.FlagLC,
  LI: Flags.FlagLI,
  LK: Flags.FlagLK,
  LR: Flags.FlagLR,
  LS: Flags.FlagLS,
  LT: Flags.FlagLT,
  LU: Flags.FlagLU,
  LV: Flags.FlagLV,
  LY: Flags.FlagLY,
  MA: Flags.FlagMA,
  MC: Flags.FlagMC,
  MD: Flags.FlagMD,
  ME: Flags.FlagME,
  MF: Flags.FlagMF,
  MG: Flags.FlagMG,
  MH: Flags.FlagMH,
  MK: Flags.FlagMK,
  ML: Flags.FlagML,
  MM: Flags.FlagMM,
  MN: Flags.FlagMN,
  MO: Flags.FlagMO,
  MP: Flags.FlagMP,
  MQ: Flags.FlagMQ,
  MR: Flags.FlagMR,
  MS: Flags.FlagMS,
  MT: Flags.FlagMT,
  MU: Flags.FlagMU,
  MV: Flags.FlagMV,
  MW: Flags.FlagMW,
  MX: Flags.FlagMX,
  MY: Flags.FlagMY,
  MZ: Flags.FlagMZ,
  NA: Flags.FlagNA,
  NC: Flags.FlagNC,
  NE: Flags.FlagNE,
  NF: Flags.FlagNF,
  NG: Flags.FlagNG,
  NI: Flags.FlagNI,
  NL: Flags.FlagNL,
  NO: Flags.FlagNO,
  NP: Flags.FlagNP,
  NR: Flags.FlagNR,
  NU: Flags.FlagNU,
  NZ: Flags.FlagNZ,
  OM: Flags.FlagOM,
  PA: Flags.FlagPA,
  PE: Flags.FlagPE,
  PF: Flags.FlagPF,
  PG: Flags.FlagPG,
  PH: Flags.FlagPH,
  PK: Flags.FlagPK,
  PL: Flags.FlagPL,
  PM: Flags.FlagPM,
  PN: Flags.FlagPN,
  PR: Flags.FlagPR,
  PS: Flags.FlagPS,
  PT: Flags.FlagPT,
  PW: Flags.FlagPW,
  PY: Flags.FlagPY,
  QA: Flags.FlagQA,
  RE: Flags.FlagRE,
  RO: Flags.FlagRO,
  RS: Flags.FlagRS,
  RU: Flags.FlagRU,
  RW: Flags.FlagRW,
  SA: Flags.FlagSA,
  SB: Flags.FlagSB,
  SC: Flags.FlagSC,
  SD: Flags.FlagSD,
  SE: Flags.FlagSE,
  SG: Flags.FlagSG,
  SH: Flags.FlagSH,
  SI: Flags.FlagSI,
  SJ: Flags.FlagSJ,
  SK: Flags.FlagSK,
  SL: Flags.FlagSL,
  SM: Flags.FlagSM,
  SN: Flags.FlagSN,
  SO: Flags.FlagSO,
  SR: Flags.FlagSR,
  SS: Flags.FlagSS,
  ST: Flags.FlagST,
  SV: Flags.FlagSV,
  SX: Flags.FlagSX,
  SY: Flags.FlagSY,
  SZ: Flags.FlagSZ,
  TC: Flags.FlagTC,
  TD: Flags.FlagTD,
  TF: Flags.FlagTF,
  TG: Flags.FlagTG,
  TH: Flags.FlagTH,
  TJ: Flags.FlagTJ,
  TK: Flags.FlagTK,
  TL: Flags.FlagTL,
  TM: Flags.FlagTM,
  TN: Flags.FlagTN,
  TO: Flags.FlagTO,
  TR: Flags.FlagTR,
  TT: Flags.FlagTT,
  TV: Flags.FlagTV,
  TW: Flags.FlagTW,
  TZ: Flags.FlagTZ,
  UA: Flags.FlagUA,
  UG: Flags.FlagUG,
  US: Flags.FlagUS,
  UY: Flags.FlagUY,
  UZ: Flags.FlagUZ,
  VA: Flags.FlagVA,
  VC: Flags.FlagVC,
  VE: Flags.FlagVE,
  VG: Flags.FlagVG,
  VI: Flags.FlagVI,
  VN: Flags.FlagVN,
  VU: Flags.FlagVU,
  WF: Flags.FlagWF,
  WS: Flags.FlagWS,
  YE: Flags.FlagYE,
  YT: Flags.FlagYT,
  ZA: Flags.FlagZA,
  ZM: Flags.FlagZM,
  ZW: Flags.FlagZW,
};

/**
 * Get flag component for a country code
 */
export const getFlag = (code: string): React.ReactNode => {
  const FlagComponent = flagMap[code.toUpperCase()];
  if (FlagComponent) {
    return <FlagComponent />;
  }
  return null;
};

/**
 * Raw country data (ISO code, name, dial code)
 * Data sourced from libphonenumber-js supported countries
 */
const countryData: Array<{ code: string; name: string; dialCode: string }> = [
  { code: "AD", name: "Andorra", dialCode: "+376" },
  { code: "AE", name: "United Arab Emirates", dialCode: "+971" },
  { code: "AF", name: "Afghanistan", dialCode: "+93" },
  { code: "AG", name: "Antigua and Barbuda", dialCode: "+1268" },
  { code: "AI", name: "Anguilla", dialCode: "+1264" },
  { code: "AL", name: "Albania", dialCode: "+355" },
  { code: "AM", name: "Armenia", dialCode: "+374" },
  { code: "AO", name: "Angola", dialCode: "+244" },
  { code: "AR", name: "Argentina", dialCode: "+54" },
  { code: "AS", name: "American Samoa", dialCode: "+1684" },
  { code: "AT", name: "Austria", dialCode: "+43" },
  { code: "AU", name: "Australia", dialCode: "+61" },
  { code: "AW", name: "Aruba", dialCode: "+297" },
  { code: "AX", name: "Åland Islands", dialCode: "+358" },
  { code: "AZ", name: "Azerbaijan", dialCode: "+994" },
  { code: "BA", name: "Bosnia and Herzegovina", dialCode: "+387" },
  { code: "BB", name: "Barbados", dialCode: "+1246" },
  { code: "BD", name: "Bangladesh", dialCode: "+880" },
  { code: "BE", name: "Belgium", dialCode: "+32" },
  { code: "BF", name: "Burkina Faso", dialCode: "+226" },
  { code: "BG", name: "Bulgaria", dialCode: "+359" },
  { code: "BH", name: "Bahrain", dialCode: "+973" },
  { code: "BI", name: "Burundi", dialCode: "+257" },
  { code: "BJ", name: "Benin", dialCode: "+229" },
  { code: "BL", name: "Saint Barthélemy", dialCode: "+590" },
  { code: "BM", name: "Bermuda", dialCode: "+1441" },
  { code: "BN", name: "Brunei", dialCode: "+673" },
  { code: "BO", name: "Bolivia", dialCode: "+591" },
  { code: "BQ", name: "Caribbean Netherlands", dialCode: "+599" },
  { code: "BR", name: "Brazil", dialCode: "+55" },
  { code: "BS", name: "Bahamas", dialCode: "+1242" },
  { code: "BT", name: "Bhutan", dialCode: "+975" },
  { code: "BW", name: "Botswana", dialCode: "+267" },
  { code: "BY", name: "Belarus", dialCode: "+375" },
  { code: "BZ", name: "Belize", dialCode: "+501" },
  { code: "CA", name: "Canada", dialCode: "+1" },
  { code: "CC", name: "Cocos (Keeling) Islands", dialCode: "+61" },
  { code: "CD", name: "DR Congo", dialCode: "+243" },
  { code: "CF", name: "Central African Republic", dialCode: "+236" },
  { code: "CG", name: "Republic of the Congo", dialCode: "+242" },
  { code: "CH", name: "Switzerland", dialCode: "+41" },
  { code: "CI", name: "Côte d'Ivoire", dialCode: "+225" },
  { code: "CK", name: "Cook Islands", dialCode: "+682" },
  { code: "CL", name: "Chile", dialCode: "+56" },
  { code: "CM", name: "Cameroon", dialCode: "+237" },
  { code: "CN", name: "China", dialCode: "+86" },
  { code: "CO", name: "Colombia", dialCode: "+57" },
  { code: "CR", name: "Costa Rica", dialCode: "+506" },
  { code: "CU", name: "Cuba", dialCode: "+53" },
  { code: "CV", name: "Cape Verde", dialCode: "+238" },
  { code: "CW", name: "Curaçao", dialCode: "+599" },
  { code: "CX", name: "Christmas Island", dialCode: "+61" },
  { code: "CY", name: "Cyprus", dialCode: "+357" },
  { code: "CZ", name: "Czech Republic", dialCode: "+420" },
  { code: "DE", name: "Germany", dialCode: "+49" },
  { code: "DJ", name: "Djibouti", dialCode: "+253" },
  { code: "DK", name: "Denmark", dialCode: "+45" },
  { code: "DM", name: "Dominica", dialCode: "+1767" },
  { code: "DO", name: "Dominican Republic", dialCode: "+1809" },
  { code: "DZ", name: "Algeria", dialCode: "+213" },
  { code: "EC", name: "Ecuador", dialCode: "+593" },
  { code: "EE", name: "Estonia", dialCode: "+372" },
  { code: "EG", name: "Egypt", dialCode: "+20" },
  { code: "EH", name: "Western Sahara", dialCode: "+212" },
  { code: "ER", name: "Eritrea", dialCode: "+291" },
  { code: "ES", name: "Spain", dialCode: "+34" },
  { code: "ET", name: "Ethiopia", dialCode: "+251" },
  { code: "FI", name: "Finland", dialCode: "+358" },
  { code: "FJ", name: "Fiji", dialCode: "+679" },
  { code: "FK", name: "Falkland Islands", dialCode: "+500" },
  { code: "FM", name: "Micronesia", dialCode: "+691" },
  { code: "FO", name: "Faroe Islands", dialCode: "+298" },
  { code: "FR", name: "France", dialCode: "+33" },
  { code: "GA", name: "Gabon", dialCode: "+241" },
  { code: "GB", name: "United Kingdom", dialCode: "+44" },
  { code: "GD", name: "Grenada", dialCode: "+1473" },
  { code: "GE", name: "Georgia", dialCode: "+995" },
  { code: "GF", name: "French Guiana", dialCode: "+594" },
  { code: "GG", name: "Guernsey", dialCode: "+44" },
  { code: "GH", name: "Ghana", dialCode: "+233" },
  { code: "GI", name: "Gibraltar", dialCode: "+350" },
  { code: "GL", name: "Greenland", dialCode: "+299" },
  { code: "GM", name: "Gambia", dialCode: "+220" },
  { code: "GN", name: "Guinea", dialCode: "+224" },
  { code: "GP", name: "Guadeloupe", dialCode: "+590" },
  { code: "GQ", name: "Equatorial Guinea", dialCode: "+240" },
  { code: "GR", name: "Greece", dialCode: "+30" },
  { code: "GT", name: "Guatemala", dialCode: "+502" },
  { code: "GU", name: "Guam", dialCode: "+1671" },
  { code: "GW", name: "Guinea-Bissau", dialCode: "+245" },
  { code: "GY", name: "Guyana", dialCode: "+592" },
  { code: "HK", name: "Hong Kong", dialCode: "+852" },
  { code: "HN", name: "Honduras", dialCode: "+504" },
  { code: "HR", name: "Croatia", dialCode: "+385" },
  { code: "HT", name: "Haiti", dialCode: "+509" },
  { code: "HU", name: "Hungary", dialCode: "+36" },
  { code: "ID", name: "Indonesia", dialCode: "+62" },
  { code: "IE", name: "Ireland", dialCode: "+353" },
  { code: "IL", name: "Israel", dialCode: "+972" },
  { code: "IM", name: "Isle of Man", dialCode: "+44" },
  { code: "IN", name: "India", dialCode: "+91" },
  { code: "IO", name: "British Indian Ocean Territory", dialCode: "+246" },
  { code: "IQ", name: "Iraq", dialCode: "+964" },
  { code: "IR", name: "Iran", dialCode: "+98" },
  { code: "IS", name: "Iceland", dialCode: "+354" },
  { code: "IT", name: "Italy", dialCode: "+39" },
  { code: "JE", name: "Jersey", dialCode: "+44" },
  { code: "JM", name: "Jamaica", dialCode: "+1876" },
  { code: "JO", name: "Jordan", dialCode: "+962" },
  { code: "JP", name: "Japan", dialCode: "+81" },
  { code: "KE", name: "Kenya", dialCode: "+254" },
  { code: "KG", name: "Kyrgyzstan", dialCode: "+996" },
  { code: "KH", name: "Cambodia", dialCode: "+855" },
  { code: "KI", name: "Kiribati", dialCode: "+686" },
  { code: "KM", name: "Comoros", dialCode: "+269" },
  { code: "KN", name: "Saint Kitts and Nevis", dialCode: "+1869" },
  { code: "KP", name: "North Korea", dialCode: "+850" },
  { code: "KR", name: "South Korea", dialCode: "+82" },
  { code: "KW", name: "Kuwait", dialCode: "+965" },
  { code: "KY", name: "Cayman Islands", dialCode: "+1345" },
  { code: "KZ", name: "Kazakhstan", dialCode: "+7" },
  { code: "LA", name: "Laos", dialCode: "+856" },
  { code: "LB", name: "Lebanon", dialCode: "+961" },
  { code: "LC", name: "Saint Lucia", dialCode: "+1758" },
  { code: "LI", name: "Liechtenstein", dialCode: "+423" },
  { code: "LK", name: "Sri Lanka", dialCode: "+94" },
  { code: "LR", name: "Liberia", dialCode: "+231" },
  { code: "LS", name: "Lesotho", dialCode: "+266" },
  { code: "LT", name: "Lithuania", dialCode: "+370" },
  { code: "LU", name: "Luxembourg", dialCode: "+352" },
  { code: "LV", name: "Latvia", dialCode: "+371" },
  { code: "LY", name: "Libya", dialCode: "+218" },
  { code: "MA", name: "Morocco", dialCode: "+212" },
  { code: "MC", name: "Monaco", dialCode: "+377" },
  { code: "MD", name: "Moldova", dialCode: "+373" },
  { code: "ME", name: "Montenegro", dialCode: "+382" },
  { code: "MF", name: "Saint Martin", dialCode: "+590" },
  { code: "MG", name: "Madagascar", dialCode: "+261" },
  { code: "MH", name: "Marshall Islands", dialCode: "+692" },
  { code: "MK", name: "North Macedonia", dialCode: "+389" },
  { code: "ML", name: "Mali", dialCode: "+223" },
  { code: "MM", name: "Myanmar", dialCode: "+95" },
  { code: "MN", name: "Mongolia", dialCode: "+976" },
  { code: "MO", name: "Macau", dialCode: "+853" },
  { code: "MP", name: "Northern Mariana Islands", dialCode: "+1670" },
  { code: "MQ", name: "Martinique", dialCode: "+596" },
  { code: "MR", name: "Mauritania", dialCode: "+222" },
  { code: "MS", name: "Montserrat", dialCode: "+1664" },
  { code: "MT", name: "Malta", dialCode: "+356" },
  { code: "MU", name: "Mauritius", dialCode: "+230" },
  { code: "MV", name: "Maldives", dialCode: "+960" },
  { code: "MW", name: "Malawi", dialCode: "+265" },
  { code: "MX", name: "Mexico", dialCode: "+52" },
  { code: "MY", name: "Malaysia", dialCode: "+60" },
  { code: "MZ", name: "Mozambique", dialCode: "+258" },
  { code: "NA", name: "Namibia", dialCode: "+264" },
  { code: "NC", name: "New Caledonia", dialCode: "+687" },
  { code: "NE", name: "Niger", dialCode: "+227" },
  { code: "NF", name: "Norfolk Island", dialCode: "+672" },
  { code: "NG", name: "Nigeria", dialCode: "+234" },
  { code: "NI", name: "Nicaragua", dialCode: "+505" },
  { code: "NL", name: "Netherlands", dialCode: "+31" },
  { code: "NO", name: "Norway", dialCode: "+47" },
  { code: "NP", name: "Nepal", dialCode: "+977" },
  { code: "NR", name: "Nauru", dialCode: "+674" },
  { code: "NU", name: "Niue", dialCode: "+683" },
  { code: "NZ", name: "New Zealand", dialCode: "+64" },
  { code: "OM", name: "Oman", dialCode: "+968" },
  { code: "PA", name: "Panama", dialCode: "+507" },
  { code: "PE", name: "Peru", dialCode: "+51" },
  { code: "PF", name: "French Polynesia", dialCode: "+689" },
  { code: "PG", name: "Papua New Guinea", dialCode: "+675" },
  { code: "PH", name: "Philippines", dialCode: "+63" },
  { code: "PK", name: "Pakistan", dialCode: "+92" },
  { code: "PL", name: "Poland", dialCode: "+48" },
  { code: "PM", name: "Saint Pierre and Miquelon", dialCode: "+508" },
  { code: "PN", name: "Pitcairn Islands", dialCode: "+64" },
  { code: "PR", name: "Puerto Rico", dialCode: "+1787" },
  { code: "PS", name: "Palestine", dialCode: "+970" },
  { code: "PT", name: "Portugal", dialCode: "+351" },
  { code: "PW", name: "Palau", dialCode: "+680" },
  { code: "PY", name: "Paraguay", dialCode: "+595" },
  { code: "QA", name: "Qatar", dialCode: "+974" },
  { code: "RE", name: "Réunion", dialCode: "+262" },
  { code: "RO", name: "Romania", dialCode: "+40" },
  { code: "RS", name: "Serbia", dialCode: "+381" },
  { code: "RU", name: "Russia", dialCode: "+7" },
  { code: "RW", name: "Rwanda", dialCode: "+250" },
  { code: "SA", name: "Saudi Arabia", dialCode: "+966" },
  { code: "SB", name: "Solomon Islands", dialCode: "+677" },
  { code: "SC", name: "Seychelles", dialCode: "+248" },
  { code: "SD", name: "Sudan", dialCode: "+249" },
  { code: "SE", name: "Sweden", dialCode: "+46" },
  { code: "SG", name: "Singapore", dialCode: "+65" },
  { code: "SH", name: "Saint Helena", dialCode: "+290" },
  { code: "SI", name: "Slovenia", dialCode: "+386" },
  { code: "SJ", name: "Svalbard and Jan Mayen", dialCode: "+47" },
  { code: "SK", name: "Slovakia", dialCode: "+421" },
  { code: "SL", name: "Sierra Leone", dialCode: "+232" },
  { code: "SM", name: "San Marino", dialCode: "+378" },
  { code: "SN", name: "Senegal", dialCode: "+221" },
  { code: "SO", name: "Somalia", dialCode: "+252" },
  { code: "SR", name: "Suriname", dialCode: "+597" },
  { code: "SS", name: "South Sudan", dialCode: "+211" },
  { code: "ST", name: "São Tomé and Príncipe", dialCode: "+239" },
  { code: "SV", name: "El Salvador", dialCode: "+503" },
  { code: "SX", name: "Sint Maarten", dialCode: "+1721" },
  { code: "SY", name: "Syria", dialCode: "+963" },
  { code: "SZ", name: "Eswatini", dialCode: "+268" },
  { code: "TC", name: "Turks and Caicos Islands", dialCode: "+1649" },
  { code: "TD", name: "Chad", dialCode: "+235" },
  { code: "TG", name: "Togo", dialCode: "+228" },
  { code: "TH", name: "Thailand", dialCode: "+66" },
  { code: "TJ", name: "Tajikistan", dialCode: "+992" },
  { code: "TK", name: "Tokelau", dialCode: "+690" },
  { code: "TL", name: "Timor-Leste", dialCode: "+670" },
  { code: "TM", name: "Turkmenistan", dialCode: "+993" },
  { code: "TN", name: "Tunisia", dialCode: "+216" },
  { code: "TO", name: "Tonga", dialCode: "+676" },
  { code: "TR", name: "Turkey", dialCode: "+90" },
  { code: "TT", name: "Trinidad and Tobago", dialCode: "+1868" },
  { code: "TV", name: "Tuvalu", dialCode: "+688" },
  { code: "TW", name: "Taiwan", dialCode: "+886" },
  { code: "TZ", name: "Tanzania", dialCode: "+255" },
  { code: "UA", name: "Ukraine", dialCode: "+380" },
  { code: "UG", name: "Uganda", dialCode: "+256" },
  { code: "US", name: "United States", dialCode: "+1" },
  { code: "UY", name: "Uruguay", dialCode: "+598" },
  { code: "UZ", name: "Uzbekistan", dialCode: "+998" },
  { code: "VA", name: "Vatican City", dialCode: "+379" },
  { code: "VC", name: "Saint Vincent and the Grenadines", dialCode: "+1784" },
  { code: "VE", name: "Venezuela", dialCode: "+58" },
  { code: "VG", name: "British Virgin Islands", dialCode: "+1284" },
  { code: "VI", name: "U.S. Virgin Islands", dialCode: "+1340" },
  { code: "VN", name: "Vietnam", dialCode: "+84" },
  { code: "VU", name: "Vanuatu", dialCode: "+678" },
  { code: "WF", name: "Wallis and Futuna", dialCode: "+681" },
  { code: "WS", name: "Samoa", dialCode: "+685" },
  { code: "YE", name: "Yemen", dialCode: "+967" },
  { code: "YT", name: "Mayotte", dialCode: "+262" },
  { code: "ZA", name: "South Africa", dialCode: "+27" },
  { code: "ZM", name: "Zambia", dialCode: "+260" },
  { code: "ZW", name: "Zimbabwe", dialCode: "+263" },
];

/**
 * Complete list of all countries with flags
 * Sorted alphabetically by name
 */
export const allCountries: Country[] = countryData
  .map((data) => ({
    ...data,
    flag: getFlag(data.code),
  }))
  .sort((a, b) => a.name.localeCompare(b.name));

/**
 * Get a country by its ISO code
 */
export const getCountryByCode = (code: string): Country | undefined => {
  return allCountries.find(
    (country) => country.code.toUpperCase() === code.toUpperCase()
  );
};

/**
 * Get a country by its dial code
 */
export const getCountryByDialCode = (dialCode: string): Country | undefined => {
  const normalizedDialCode = dialCode.startsWith("+")
    ? dialCode
    : `+${dialCode}`;
  return allCountries.find(
    (country) => country.dialCode === normalizedDialCode
  );
};

/**
 * Get a placeholder by country
 */
export function getPlaceholderByCode(code?: string) {
  if (!code) return undefined;

  try {
    const example = getExampleNumber(
      code.toUpperCase() as CountryCode,
      examples
    );

    if (!example) return undefined;

    return (
      "+" +
      example.countryCallingCode +
      example
        .formatInternational()
        .slice(example.countryCallingCode.length + 1)
        .replace(/\d/g, "0")
    );
  } catch {
    return undefined;
  }
}

/**
 * Default countries (commonly used)
 */
export const defaultCountries: Country[] = [
  getCountryByCode("US")!,
  getCountryByCode("GB")!,
  getCountryByCode("CA")!,
  getCountryByCode("AU")!,
  getCountryByCode("DE")!,
  getCountryByCode("FR")!,
  getCountryByCode("ES")!,
  getCountryByCode("IT")!,
  getCountryByCode("JP")!,
  getCountryByCode("CN")!,
  getCountryByCode("IN")!,
  getCountryByCode("BR")!,
  getCountryByCode("RU")!,
  getCountryByCode("MY")!,
  getCountryByCode("SG")!,
].filter(Boolean);

export default allCountries;
